import InnerPageTech from './innerPageTech'
import TemplateMain from '../templateMain'
import { useParams } from 'react-router-dom'
import { SLIDESHOWS } from '../../types'

export default function PageTech () {
  const { topic } = useParams()
  return (
    <TemplateMain
      g_section='portfolio'
      htmlTitle='Tech'
      linksTitle='Other Site Links'
      innerPage={<InnerPageTech topic={topic} />}
      g_sidebarKey='potpourri'
      g_slideshowKey={SLIDESHOWS.logos}
    />
  )
}
